import React from "react";
import TradersListPage from "./TradersListPage";

/** Blocked users route — data from GET /v1/admin/users/blocked. */
const BlockedTradersListPage = () => <TradersListPage variant="blocked" />;

export default BlockedTradersListPage;
